import { Box, IconButton, TableCell, TableRow, Theme, Typography } from "@mui/material";
import { ActionIcon } from "../../assets/SvgIcons";
import theme from "../../themes/default";
import type { TableHeaderData } from "../investorOverview/types";
import { useSelector } from "react-redux";
import { RootStateType } from "../../redux-store/reducers";
import { formatCurrency } from "../../utils/utilityFunctions";

export interface FamilyMemberRow {
    id: string;
    name: string;
    roleLabel?: string;
    investorCode?: string;
    investorPan?: string;
    phoneNumber: string;
    email: string;
    aum: number;
}

export const familyMembersTableHeader: TableHeaderData[] = [
    { id: "name", label: "FAMILY MEMBER", align: "left", isSortable: false },
    { id: "investorCode", label: "INVESTOR CODE", align: "center", isSortable: false },
    // { id: "investorPan", label: "INVESTOR PAN", align: "center", isSortable: false },
    { id: "phoneNumber", label: "PHONE NUMBER", align: "center", isSortable: false },
    { id: "email", label: "EMAIL", align: "center", isSortable: false },
    { id: "aum", label: "AUM", align: "center", isSortable: false },
    { id: "actions", label: "ACTIONS", align: "center", isSortable: false },
];

interface FamilyMemberTableBodyProps {
    data: FamilyMemberRow[];
    anchorEl: HTMLElement | null;
    onOpenMenu: (event: React.MouseEvent<HTMLButtonElement>, memberId: string) => void;
}

export default function FamilyMemberTableBody({
    data,
    anchorEl,
    onOpenMenu,
}: FamilyMemberTableBodyProps): JSX.Element {

    return (
        <>
            {data.map((row) => (
                <TableRow
                    key={row.id}
                    hover
                    sx={{
                        "& td": {
                            paddingTop: "0.6rem",
                            paddingBottom: "0.6rem",
                        },
                        "& td:first-of-type": { paddingLeft: "0px" },
                        "&:last-child td": { border: 0 },
                    }}
                >
                    <TableCell
                        align="left"
                        sx={(t: Theme) => ({
                            ...theme.typography.body_500,
                            borderBottom: `1px solid ${t.palette.grey[100]}`,
                        })}
                    >
                        <Box>
                            <Box sx={{ display: "flex", alignItems: "center", gap: "8px", whiteSpace: "nowrap" }}>
                                <Typography variant="body_500"
                                    sx={(t: Theme) => ({
                                        color: t.palette.primary[500],
                                    })}
                                >
                                    {row.name}
                                </Typography>
                                {row.roleLabel && (
                                    <Box
                                        sx={(t: Theme) => ({
                                            display: "flex",
                                            padding: "0 10px",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            whiteSpace: "nowrap",
                                            gap: "10px",
                                            borderRadius: "8px",
                                            background:
                                                t.palette.primary[100],
                                            color: t.palette.primary[500],
                                        })}
                                    >
                                        <Typography variant="subtitle_500"
                                            sx={(t: Theme) => ({
                                                ...theme.typography.body_400,  
                                                color: t.palette.primary[500],
                                            })}
                                        >
                                            {row.roleLabel}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </TableCell>
                    <TableCell
                        align="center"
                        sx={(t: Theme) => ({
                            ...theme.typography.body_400,
                            fontWeight: 500,
                            borderBottom: `1px solid ${t.palette.grey[100]}`,
                        })}
                    >
                        {row.investorCode}
                    </TableCell>
                    {/* <TableCell
                        align="center"
                        sx={(t: Theme) => ({
                            ...theme.typography.body_400,
                            fontWeight: 500,
                            borderBottom: `1px solid ${t.palette.grey[100]}`,
                        })}
                     >
                        {row.investorPan}
                    </TableCell> */}
                    <TableCell
                        align="center"
                        sx={(t: Theme) => ({
                            ...theme.typography.body_400,
                            fontWeight: 500,
                            borderBottom: `1px solid ${t.palette.grey[100]}`,
                        })}
                    >
                        {row.phoneNumber}
                    </TableCell>
                    <TableCell
                        align="center"
                        sx={(t: Theme) => ({
                            ...theme.typography.body_400,
                            fontWeight: 500,
                            borderBottom: `1px solid ${t.palette.grey[100]}`,
                        })}
                    >
                        {row.email}
                    </TableCell>
                    <TableCell
                        align="center"
                        sx={(t: Theme) => ({
                            ...theme.typography.body_400,
                            fontWeight: 500,
                            borderBottom: `1px solid ${t.palette.grey[100]}`,
                        })}
                    >
                     {formatCurrency({ value: row.aum ?? 0, locale: "en-IN", currencyCode: "INR" })}
                    </TableCell>
                    <TableCell
                        align="center"
                        sx={(t: Theme) => ({
                            borderBottom: `1px solid ${t.palette.grey[100]}`,
                        })}
                    >
                        {row.roleLabel !== "Family Head" && (
                            <IconButton
                                size="small"
                                aria-label="family-menu"
                                aria-controls={anchorEl ? "family-menu" : undefined}
                                aria-haspopup="true"
                                aria-expanded={anchorEl ? "true" : undefined}
                                sx={{
                                    padding: 0,
                                    "&:hover": { backgroundColor: "transparent" },
                                    color: theme.palette.text.secondary,
                                }}
                                onClick={(event) => onOpenMenu(event, row.id)}
                            >
                                <ActionIcon />
                            </IconButton>
                        )}
                    </TableCell>
                </TableRow>
            ))}
        </>
    );
}
